// src/components/ScrollToTop.tsx
import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const JOURNAL_FOCUS_SCROLL_STATE = "__nimosJournalFocusScroll";

export default function ScrollToTop() {
  const { pathname, search, hash, state } = useLocation();
  const previousPathname = useRef<string | null>(null);
  const preserveJournalFocus = /^\/company\/[^/]+\/general-journal\/?$/.test(pathname) &&
    state?.[JOURNAL_FOCUS_SCROLL_STATE] === true;
  const navType = useNavigationType(); // "PUSH" | "REPLACE" | "POP"

  useEffect(() => {
    const samePath = previousPathname.current === pathname;
    previousPathname.current = pathname;
    // Keep scroll position on browser back/forward
    if (navType === "POP") return;

    // If navigating to an anchor, let the browser handle it
    if (hash) return;

    // Only the journal's automatic focus replacements opt out. PUSH, path
    // changes and every other page retain the existing reset policy.
    if (navType === "REPLACE" && samePath && preserveJournalFocus) return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash, navType, preserveJournalFocus]);

  return null;
}
